// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"953616d0","513":"639a0403","703":"705680ea"}[chunkId] + ".chunk.js";
};